import { Link } from 'react-router-dom';
import Layout from '../../../components/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { ArrowLeft, FileText, Shield, Settings } from 'lucide-react';

export default function AssetsReports() {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Button variant="ghost" onClick={() => window.history.back()} className="mb-4 -ml-2">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Assets & Stock reports</h1>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            Insurance exports, location reports, and VAT pre-registration reclaim (advisory).
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <Card className="bg-white dark:bg-gray-800">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-gray-900 dark:text-gray-100">
                <Shield className="h-5 w-5" />
                Insurance & location
              </CardTitle>
              <CardDescription className="text-gray-600 dark:text-gray-400">
                Active assets, by location/van/employee, lost/stolen, or full insurance valuation. Export CSV or PDF.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/tenant/assets/reports/insurance">
                <Button>Open report</Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-gray-900 dark:text-gray-100">
                <FileText className="h-5 w-5" />
                VAT pre-registration reclaim
              </CardTitle>
              <CardDescription className="text-gray-600 dark:text-gray-400">
                Advisory report of assets purchased before VAT registration with review status tracking.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/tenant/assets/vat-reclaim">
                <Button>Open report</Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 sm:col-span-2">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-gray-900 dark:text-gray-100">
                <Settings className="h-5 w-5" />
                Module settings
              </CardTitle>
              <CardDescription className="text-gray-600 dark:text-gray-400">
                Set your VAT registration date used for the pre-registration reclaim report window.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/tenant/assets/settings">
                <Button variant="outline">Assets settings</Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
